<a href="javascript:;"
   class="btn notification-btn"
   [ngClass]="{'new': notificationCount > 0}"
   (click)="openNotifications()"
   mtgFireEvent="notificationsClicked"
>
  <span class="icon-bell-new"></span>
</a>
